import { projectLandingHostKeySchema } from '@rw/contracts';

export function resolvePublicLandingHostKey(hostname: string): string | null {
  const candidate = hostname.toLowerCase().split('.')[0] ?? '';
  const parsed = projectLandingHostKeySchema.safeParse(candidate);
  return parsed.success ? parsed.data : null;
}

export function publicLandingAttribution(location: Location, referrer: string) {
  const parameters = new URLSearchParams(location.search);
  const value = (name: string) => parameters.get(name)?.trim() || null;
  const parsedReferrer = /^https?:\/\//iu.test(referrer) ? referrer : null;
  return {
    utmSource: value('utm_source'),
    utmMedium: value('utm_medium'),
    utmCampaign: value('utm_campaign'),
    utmContent: value('utm_content'),
    utmTerm: value('utm_term'),
    yclid: value('yclid'),
    referrer: parsedReferrer,
  };
}
